import { findIndex } from 'lodash/fp';

import type { RecentEntitiesModel } from 'core/services/recent-entities-service/recent-entities-model';

export const getUniqueSearchResults = (searchResults: RecentEntitiesModel[]) => {
    const uniqValues = searchResults.filter((searchResult, index) => {
        const firstVenueIndex = findIndex(
            {
                id: searchResult.id,
                type: searchResult?.type,
            },
            searchResults,
        );

        return firstVenueIndex === index;
    });
    return uniqValues;
};
